import { API } from 'src/api';

import { workspaceFilter } from '../types/lms';

export const useLMSDashboardService = () => {
  async function newfetchAllWorkspace(filter: workspaceFilter) {
    try {
      const { search, sort } = filter;
      const response = await API.get(`/workspace?type=org&lms=true&sort=${sort}&search=${search}`);
      if (response.data.success) {
        console.error('response', response.data);
        return response.data.data.data;
      }
    } catch (error) {
      console.error('error', error);
      return null;
    }
    return null;
  }

  async function setLmsMode(value: string) {
    try {
      const response = await API.put('/settings/preferences', {
        lms_mode: value,
      });

      if (response.data.success) {
        return response.data.data;
      }
    } catch (error) {
      console.error(error);
      return null;
    }
    return null;
  }

  async function getLmsMode() {
    try {
      const response = await API.get('/settings');

      if (response.data.success) {
        return response.data.data.preferences.lms_mode;
      }
    } catch (error) {
      console.error(error);
      return null;
    }
    return null;
  }

  async function getUserDetail() {
    try {
      const response = await API.get('/settings');

      if (response.data.success) {
        return response.data;
      }
    } catch (error) {
      console.error(error);
      return null;
    }
    return null;
  }

  async function setLmsTourMode(value: boolean) {
    try {
      const response = await API.put('/settings/preferences', {
        lms_tour: value,
      });

      if (response.data.success) {
        return response.data.data;
      }
    } catch (error) {
      console.error(error);
      return null;
    }
    return null;
  }

  async function inviteUserOnOrg(paylod: any) {
    try {
      const response = await API.post('/user/invite', {
        role: paylod.role,
        emails: paylod.emails,
      });

      if (response.data.success) {
        return response.data.data;
      }
    } catch (error) {
      console.error(error);
      return null;
    }
    return null;
  }

  async function getLmsTourMode() {
    try {
      const response = await API.get('/settings');

      if (response.data.success) {
        return response.data.data.preferences.lms_tour;
      }
    } catch (error) {
      console.error(error);
      return null;
    }
    return null;
  }

  async function fetchTopLesson() {
    try {
      const response = await API.get(
        '/lms/lesson?state=published&top=true&limit=5&page=1&sort=recent'
      );
      if (response.data.success) {
        return response.data.data.docs;
      }
    } catch (error) {
      console.error('error', error);
      return [];
    }
    return [];
  }

  async function fetchEnrolments(lessonId: string) {
    try {
      const response = await API.post(`/lms/lesson/enrolment?lesson=${lessonId}`);

      if (response.data.success) {
        return response.data.data;
      }
    } catch (error) {
      console.error(error);
      return null;
    }
    return null;
  }

  async function getAnalytics(lessonId: string) {
    try {
      const response = await API.get(`/lms/lesson/analytics?id=${lessonId}`);

      if (response.data.success) {
        return response.data.data;
      }
    } catch (error) {
      console.error(error);
      return null;
    }
    return null;
  }

  async function getQuizUsersList(
    lessonId: string,
    quizId: string,
    sort?: string,
    excAftDadlinePass?: boolean
  ) {
    try {
      let apiUrl = `/lms/lesson/analytics/quiz/users?id=${lessonId}&quizId=${quizId}`;

      if (sort) {
        apiUrl = apiUrl + `&dateSort=${sort}`;
      }

      if (excAftDadlinePass) {
        apiUrl = apiUrl + `&excAftDadlinePass=true`;
      }

      const response = await API.get(apiUrl);

      if (response.data.success) {
        return response.data.data;
      }
    } catch (error) {
      console.error(error);
      return null;
    }
    return null;
  }

  async function getQuizUsersQuestionsData(lessonId: string, quizId: string, memberId: string) {
    try {
      const response = await API.get(
        `/lms/lesson/analytics/questions?id=${lessonId}&quizId=${quizId}&memberId=${memberId}`
      );

      if (response.data.success) {
        return response.data.data;
      }
    } catch (error) {
      console.error(error);
      return null;
    }
    return null;
  }

  async function getQuizSummaryData(lessonId: string, quizId: string) {
    try {
      const response = await API.get(
        `/lms/lesson/analytics/quizSummary?id=${lessonId}&quizId=${quizId}`
      );

      if (response.data.success) {
        return response.data.data;
      }
    } catch (error) {
      console.error(error);
      return null;
    }
    return null;
  }

  return {
    newfetchAllWorkspace,
    fetchTopLesson,
    fetchEnrolments,
    setLmsMode,
    getLmsMode,
    setLmsTourMode,
    getLmsTourMode,
    getUserDetail,
    inviteUserOnOrg,
    getAnalytics,
    getQuizUsersList,
    getQuizUsersQuestionsData,
    getQuizSummaryData,
  };
};
